import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../navigation';

interface DashboardSummaryProps {
  taskCount: number;
  contentSetCount: number;
  username: string;
}

const DashboardSummary: React.FC<DashboardSummaryProps> = ({
  taskCount,
  contentSetCount,
  username
}) => {
  return (
    <div className="dashboard-summary">
      <h2>Welcome, {username}!</h2>
      <p className="dashboard-subtitle">Here's a quick overview of your resources</p>

      <div className="dashboard-cards">
        <Link to={ROUTES.CONTENT} className="dashboard-card-link">
          <div className="dashboard-card">
            <div className="dashboard-card-icon">📚</div>
            <div className="dashboard-card-content">
              <div className="dashboard-card-number">{contentSetCount}</div>
              <div className="dashboard-card-label">
                {contentSetCount === 1 ? 'Content Set' : 'Content Sets'}
              </div>
            </div>
          </div>
        </Link>

        <Link to={ROUTES.TASKS_LIST} className="dashboard-card-link">
          <div className="dashboard-card">
            <div className="dashboard-card-icon">📝</div>
            <div className="dashboard-card-content">
              <div className="dashboard-card-number">{taskCount}</div>
              <div className="dashboard-card-label">
                {taskCount === 1 ? 'Task' : 'Tasks'}
              </div>
            </div>
          </div>
        </Link>
      </div>

      <p style={{ marginTop: '1.5rem', color: '#6c757d', fontSize: '0.9rem', textAlign: 'center' }}>
        Use the <a href="https://www.gamestolearnenglish.com/pages/contact/" target="_blank" rel="noreferrer">contact form</a> to make suggestions about this teachers' section.
      </p>
    </div>
  );
};

export default DashboardSummary;
